import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card card-flush" }
const _hoisted_2 = { class: "card-header mt-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center position-relative my-1 me-5" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-1 position-absolute ms-6" }, [
      /*#__PURE__*/_createElementVNode("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
      }, [
        /*#__PURE__*/_createElementVNode("rect", {
          opacity: "0.5",
          x: "17.0365",
          y: "15.1223",
          width: "8.15546",
          height: "2",
          rx: "1",
          transform: "rotate(45 17.0365 15.1223)",
          "1": ""
        }),
        /*#__PURE__*/_createElementVNode("path", {
          d: "M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z",
          fill: "black"
        })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("input", {
      type: "text",
      "data-kt-permissions-table-filter": "search",
      class: "form-control form-control-solid w-250px ps-15",
      placeholder: "Search Permissions"
    })
  ])
], -1)
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = {
  type: "button",
  class: "btn btn-light-primary",
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_modal_add_permission"
}
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<span class=\"svg-icon svg-icon-3\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\"><rect opacity=\"0.3\" x=\"2\" y=\"2\" width=\"20\" height=\"20\" rx=\"5\" fill=\"black\"></rect><rect x=\"10.8891\" y=\"17.8033\" width=\"12\" height=\"2\" rx=\"1\" transform=\"rotate(-90 10.8891 17.8033)\" fill=\"black\"></rect><rect x=\"6.01041\" y=\"10.9247\" width=\"12\" height=\"2\" rx=\"1\" fill=\"black\"></rect></svg></span>", 1)
const _hoisted_7 = { class: "card-body pt-0" }
const _hoisted_8 = {
  class: "table align-middle table-row-dashed fs-6 gy-5 mb-0",
  id: "kt_permissions_table"
}
const _hoisted_9 = { class: "text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0" }
const _hoisted_10 = { class: "min-w-125px" }
const _hoisted_11 = { class: "min-w-250px" }
const _hoisted_12 = { class: "min-w-125px" }
const _hoisted_13 = { class: "text-end min-w-100px" }
const _hoisted_14 = { class: "fw-bold text-gray-600" }
const _hoisted_15 = {
  href: "../../demo1/dist/apps/user-management/roles/view.html",
  class: "badge badge-light-primary fs-7 m-1"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("td", null, "22 Sep 2021, 10:10 pm", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-icon btn-active-light-primary w-30px h-30px me-3",
    "data-bs-toggle": "modal",
    "data-bs-target": "#kt_modal_update_permission"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3" }, [
      /*#__PURE__*/_createElementVNode("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
      }, [
        /*#__PURE__*/_createElementVNode("path", {
          d: "M17.5 11H6.5C4 11 2 9 2 6.5C2 4 4 2 6.5 2H17.5C20 2 22 4 22 6.5C22 9 20 11 17.5 11ZM15 6.5C15 7.9 16.1 9 17.5 9C18.9 9 20 7.9 20 6.5C20 5.1 18.9 4 17.5 4C16.1 4 15 5.1 15 6.5Z",
          fill: "black"
        }),
        /*#__PURE__*/_createElementVNode("path", {
          opacity: "0.3",
          d: "M17.5 22H6.5C4 22 2 20 2 17.5C2 15 4 13 6.5 13H17.5C20 13 22 15 22 17.5C22 20 20 22 17.5 22ZM4 17.5C4 18.9 5.1 20 6.5 20C7.9 20 9 18.9 9 17.5C9 16.1 7.9 15 6.5 15C5.1 15 4 16.1 4 17.5Z",
          fill: "black"
        })
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-icon btn-active-light-primary w-30px h-30px",
    "data-kt-permissions-table-filter": "delete_row"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3" }, [
      /*#__PURE__*/_createElementVNode("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
      }, [
        /*#__PURE__*/_createElementVNode("path", {
          d: "M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z",
          fill: "black"
        }),
        /*#__PURE__*/_createElementVNode("path", {
          opacity: "0.5",
          d: "M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z",
          fill: "black"
        }),
        /*#__PURE__*/_createElementVNode("path", {
          opacity: "0.5",
          d: "M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z",
          fill: "black"
        })
      ])
    ])
  ])
], -1)
const _hoisted_18 = {
  href: "../../demo1/dist/apps/user-management/roles/view.html",
  class: "badge badge-light-primary fs-7 m-1"
}
const _hoisted_19 = {
  href: "../../demo1/dist/apps/user-management/roles/view.html",
  class: "badge badge-light-danger fs-7 m-1"
}
const _hoisted_20 = {
  href: "../../demo1/dist/apps/user-management/roles/view.html",
  class: "badge badge-light-success fs-7 m-1"
}
const _hoisted_21 = {
  href: "../../demo1/dist/apps/user-management/roles/view.html",
  class: "badge badge-light-primary fs-7 m-1"
}
const _hoisted_22 = {
  href: "../../demo1/dist/apps/user-management/roles/view.html",
  class: "badge badge-light-warning fs-7 m-1"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("td", null, "25 Oct 2021, 10:10 pm", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-icon btn-active-light-primary w-30px h-30px me-3",
    "data-bs-toggle": "modal",
    "data-bs-target": "#kt_modal_update_permission"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3" }, [
      /*#__PURE__*/_createElementVNode("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
      }, [
        /*#__PURE__*/_createElementVNode("path", {
          d: "M17.5 11H6.5C4 11 2 9 2 6.5C2 4 4 2 6.5 2H17.5C20 2 22 4 22 6.5C22 9 20 11 17.5 11ZM15 6.5C15 7.9 16.1 9 17.5 9C18.9 9 20 7.9 20 6.5C20 5.1 18.9 4 17.5 4C16.1 4 15 5.1 15 6.5Z",
          fill: "black"
        }),
        /*#__PURE__*/_createElementVNode("path", {
          opacity: "0.3",
          d: "M17.5 22H6.5C4 22 2 20 2 17.5C2 15 4 13 6.5 13H17.5C20 13 22 15 22 17.5C22 20 20 22 17.5 22ZM4 17.5C4 18.9 5.1 20 6.5 20C7.9 20 9 18.9 9 17.5C9 16.1 7.9 15 6.5 15C5.1 15 4 16.1 4 17.5Z",
          fill: "black"
        })
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-icon btn-active-light-primary w-30px h-30px",
    "data-kt-permissions-table-filter": "delete_row"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3" }, [
      /*#__PURE__*/_createElementVNode("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
      }, [
        /*#__PURE__*/_createElementVNode("path", {
          d: "M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z",
          fill: "black"
        }),
        /*#__PURE__*/_createElementVNode("path", {
          opacity: "0.5",
          d: "M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z",
          fill: "black"
        }),
        /*#__PURE__*/_createElementVNode("path", {
          opacity: "0.5",
          d: "M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z",
          fill: "black"
        })
      ])
    ])
  ])
], -1)
const _hoisted_25 = {
  href: "../../demo1/dist/apps/user-management/roles/view.html",
  class: "badge badge-light-primary fs-7 m-1"
}
const _hoisted_26 = {
  href: "../../demo1/dist/apps/user-management/roles/view.html",
  class: "badge badge-light-success fs-7 m-1"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("td", null, "05 May 2021, 11:05 am", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-icon btn-active-light-primary w-30px h-30px me-3",
    "data-bs-toggle": "modal",
    "data-bs-target": "#kt_modal_update_permission"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3" }, [
      /*#__PURE__*/_createElementVNode("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
      }, [
        /*#__PURE__*/_createElementVNode("path", {
          d: "M17.5 11H6.5C4 11 2 9 2 6.5C2 4 4 2 6.5 2H17.5C20 2 22 4 22 6.5C22 9 20 11 17.5 11ZM15 6.5C15 7.9 16.1 9 17.5 9C18.9 9 20 7.9 20 6.5C20 5.1 18.9 4 17.5 4C16.1 4 15 5.1 15 6.5Z",
          fill: "black"
        }),
        /*#__PURE__*/_createElementVNode("path", {
          opacity: "0.3",
          d: "M17.5 22H6.5C4 22 2 20 2 17.5C2 15 4 13 6.5 13H17.5C20 13 22 15 22 17.5C22 20 20 22 17.5 22ZM4 17.5C4 18.9 5.1 20 6.5 20C7.9 20 9 18.9 9 17.5C9 16.1 7.9 15 6.5 15C5.1 15 4 16.1 4 17.5Z",
          fill: "black"
        })
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-icon btn-active-light-primary w-30px h-30px",
    "data-kt-permissions-table-filter": "delete_row"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3" }, [
      /*#__PURE__*/_createElementVNode("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
      }, [
        /*#__PURE__*/_createElementVNode("path", {
          d: "M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z",
          fill: "black"
        }),
        /*#__PURE__*/_createElementVNode("path", {
          opacity: "0.5",
          d: "M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z",
          fill: "black"
        }),
        /*#__PURE__*/_createElementVNode("path", {
          opacity: "0.5",
          d: "M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z",
          fill: "black"
        })
      ])
    ])
  ])
], -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("td", null, "Reporting", -1)
const _hoisted_30 = {
  href: "../../demo1/dist/apps/user-management/roles/view.html",
  class: "badge badge-light-primary fs-7 m-1"
}
const _hoisted_31 = {
  href: "../../demo1/dist/apps/user-management/roles/view.html",
  class: "badge badge-light-success fs-7 m-1"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("td", null, "22 Sep 2021, 5:30 pm", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-icon btn-active-light-primary w-30px h-30px me-3",
    "data-bs-toggle": "modal",
    "data-bs-target": "#kt_modal_update_permission"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3" }, [
      /*#__PURE__*/_createElementVNode("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
      }, [
        /*#__PURE__*/_createElementVNode("path", {
          d: "M17.5 11H6.5C4 11 2 9 2 6.5C2 4 4 2 6.5 2H17.5C20 2 22 4 22 6.5C22 9 20 11 17.5 11ZM15 6.5C15 7.9 16.1 9 17.5 9C18.9 9 20 7.9 20 6.5C20 5.1 18.9 4 17.5 4C16.1 4 15 5.1 15 6.5Z",
          fill: "black"
        }),
        /*#__PURE__*/_createElementVNode("path", {
          opacity: "0.3",
          d: "M17.5 22H6.5C4 22 2 20 2 17.5C2 15 4 13 6.5 13H17.5C20 13 22 15 22 17.5C22 20 20 22 17.5 22ZM4 17.5C4 18.9 5.1 20 6.5 20C7.9 20 9 18.9 9 17.5C9 16.1 7.9 15 6.5 15C5.1 15 4 16.1 4 17.5Z",
          fill: "black"
        })
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-icon btn-active-light-primary w-30px h-30px",
    "data-kt-permissions-table-filter": "delete_row"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3" }, [
      /*#__PURE__*/_createElementVNode("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
      }, [
        /*#__PURE__*/_createElementVNode("path", {
          d: "M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z",
          fill: "black"
        }),
        /*#__PURE__*/_createElementVNode("path", {
          opacity: "0.5",
          d: "M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z",
          fill: "black"
        }),
        /*#__PURE__*/_createElementVNode("path", {
          opacity: "0.5",
          d: "M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z",
          fill: "black"
        })
      ])
    ])
  ])
], -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("td", null, "Payroll", -1)
const _hoisted_35 = {
  href: "../../demo1/dist/apps/user-management/roles/view.html",
  class: "badge badge-light-primary fs-7 m-1"
}
const _hoisted_36 = {
  href: "../../demo1/dist/apps/user-management/roles/view.html",
  class: "badge badge-light-success fs-7 m-1"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("td", null, "10 Nov 2021, 10:30 am", -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-icon btn-active-light-primary w-30px h-30px me-3",
    "data-bs-toggle": "modal",
    "data-bs-target": "#kt_modal_update_permission"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3" }, [
      /*#__PURE__*/_createElementVNode("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
      }, [
        /*#__PURE__*/_createElementVNode("path", {
          d: "M17.5 11H6.5C4 11 2 9 2 6.5C2 4 4 2 6.5 2H17.5C20 2 22 4 22 6.5C22 9 20 11 17.5 11ZM15 6.5C15 7.9 16.1 9 17.5 9C18.9 9 20 7.9 20 6.5C20 5.1 18.9 4 17.5 4C16.1 4 15 5.1 15 6.5Z",
          fill: "black"
        }),
        /*#__PURE__*/_createElementVNode("path", {
          opacity: "0.3",
          d: "M17.5 22H6.5C4 22 2 20 2 17.5C2 15 4 13 6.5 13H17.5C20 13 22 15 22 17.5C22 20 20 22 17.5 22ZM4 17.5C4 18.9 5.1 20 6.5 20C7.9 20 9 18.9 9 17.5C9 16.1 7.9 15 6.5 15C5.1 15 4 16.1 4 17.5Z",
          fill: "black"
        })
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-icon btn-active-light-primary w-30px h-30px",
    "data-kt-permissions-table-filter": "delete_row"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3" }, [
      /*#__PURE__*/_createElementVNode("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
      }, [
        /*#__PURE__*/_createElementVNode("path", {
          d: "M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z",
          fill: "black"
        }),
        /*#__PURE__*/_createElementVNode("path", {
          opacity: "0.5",
          d: "M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z",
          fill: "black"
        }),
        /*#__PURE__*/_createElementVNode("path", {
          opacity: "0.5",
          d: "M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z",
          fill: "black"
        })
      ])
    ])
  ])
], -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("td", null, "Disputes Management", -1)
const _hoisted_40 = {
  href: "../../demo1/dist/apps/user-management/roles/view.html",
  class: "badge badge-light-primary fs-7 m-1"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("a", {
  href: "../../demo1/dist/apps/user-management/roles/view.html",
  class: "badge badge-light-danger fs-7 m-1"
}, "Developer", -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("a", {
  href: "../../demo1/dist/apps/user-management/roles/view.html",
  class: "badge badge-light-primary fs-7 m-1"
}, "Support", -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("td", null, "24 Jun 2021, 10:30 am", -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-icon btn-active-light-primary w-30px h-30px me-3",
    "data-bs-toggle": "modal",
    "data-bs-target": "#kt_modal_update_permission"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3" }, [
      /*#__PURE__*/_createElementVNode("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
      }, [
        /*#__PURE__*/_createElementVNode("path", {
          d: "M17.5 11H6.5C4 11 2 9 2 6.5C2 4 4 2 6.5 2H17.5C20 2 22 4 22 6.5C22 9 20 11 17.5 11ZM15 6.5C15 7.9 16.1 9 17.5 9C18.9 9 20 7.9 20 6.5C20 5.1 18.9 4 17.5 4C16.1 4 15 5.1 15 6.5Z",
          fill: "black"
        }),
        /*#__PURE__*/_createElementVNode("path", {
          opacity: "0.3",
          d: "M17.5 22H6.5C4 22 2 20 2 17.5C2 15 4 13 6.5 13H17.5C20 13 22 15 22 17.5C22 20 20 22 17.5 22ZM4 17.5C4 18.9 5.1 20 6.5 20C7.9 20 9 18.9 9 17.5C9 16.1 7.9 15 6.5 15C5.1 15 4 16.1 4 17.5Z",
          fill: "black"
        })
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-icon btn-active-light-primary w-30px h-30px",
    "data-kt-permissions-table-filter": "delete_row"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3" }, [
      /*#__PURE__*/_createElementVNode("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
      }, [
        /*#__PURE__*/_createElementVNode("path", {
          d: "M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z",
          fill: "black"
        }),
        /*#__PURE__*/_createElementVNode("path", {
          opacity: "0.5",
          d: "M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z",
          fill: "black"
        }),
        /*#__PURE__*/_createElementVNode("path", {
          opacity: "0.5",
          d: "M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z",
          fill: "black"
        })
      ])
    ])
  ])
], -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("td", null, "API Controls", -1)
const _hoisted_46 = {
  href: "../../demo1/dist/apps/user-management/roles/view.html",
  class: "badge badge-light-primary fs-7 m-1"
}
const _hoisted_47 = {
  href: "../../demo1/dist/apps/user-management/roles/view.html",
  class: "badge badge-light-danger fs-7 m-1"
}
const _hoisted_48 = /*#__PURE__*/_createElementVNode("td", null, "21 Feb 2021, 2:40 pm", -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-icon btn-active-light-primary w-30px h-30px me-3",
    "data-bs-toggle": "modal",
    "data-bs-target": "#kt_modal_update_permission"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3" }, [
      /*#__PURE__*/_createElementVNode("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
      }, [
        /*#__PURE__*/_createElementVNode("path", {
          d: "M17.5 11H6.5C4 11 2 9 2 6.5C2 4 4 2 6.5 2H17.5C20 2 22 4 22 6.5C22 9 20 11 17.5 11ZM15 6.5C15 7.9 16.1 9 17.5 9C18.9 9 20 7.9 20 6.5C20 5.1 18.9 4 17.5 4C16.1 4 15 5.1 15 6.5Z",
          fill: "black"
        }),
        /*#__PURE__*/_createElementVNode("path", {
          opacity: "0.3",
          d: "M17.5 22H6.5C4 22 2 20 2 17.5C2 15 4 13 6.5 13H17.5C20 13 22 15 22 17.5C22 20 20 22 17.5 22ZM4 17.5C4 18.9 5.1 20 6.5 20C7.9 20 9 18.9 9 17.5C9 16.1 7.9 15 6.5 15C5.1 15 4 16.1 4 17.5Z",
          fill: "black"
        })
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-icon btn-active-light-primary w-30px h-30px",
    "data-kt-permissions-table-filter": "delete_row"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3" }, [
      /*#__PURE__*/_createElementVNode("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
      }, [
        /*#__PURE__*/_createElementVNode("path", {
          d: "M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z",
          fill: "black"
        }),
        /*#__PURE__*/_createElementVNode("path", {
          opacity: "0.5",
          d: "M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z",
          fill: "black"
        }),
        /*#__PURE__*/_createElementVNode("path", {
          opacity: "0.5",
          d: "M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z",
          fill: "black"
        })
      ])
    ])
  ])
], -1)
const _hoisted_50 = {
  href: "../../demo1/dist/apps/user-management/roles/view.html",
  class: "badge badge-light-primary fs-7 m-1"
}
const _hoisted_51 = {
  href: "../../demo1/dist/apps/user-management/roles/view.html",
  class: "badge badge-light-danger fs-7 m-1"
}
const _hoisted_52 = /*#__PURE__*/_createElementVNode("td", null, "19 Aug 2021, 11:05 am", -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-icon btn-active-light-primary w-30px h-30px me-3",
    "data-bs-toggle": "modal",
    "data-bs-target": "#kt_modal_update_permission"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3" }, [
      /*#__PURE__*/_createElementVNode("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
      }, [
        /*#__PURE__*/_createElementVNode("path", {
          d: "M17.5 11H6.5C4 11 2 9 2 6.5C2 4 4 2 6.5 2H17.5C20 2 22 4 22 6.5C22 9 20 11 17.5 11ZM15 6.5C15 7.9 16.1 9 17.5 9C18.9 9 20 7.9 20 6.5C20 5.1 18.9 4 17.5 4C16.1 4 15 5.1 15 6.5Z",
          fill: "black"
        }),
        /*#__PURE__*/_createElementVNode("path", {
          opacity: "0.3",
          d: "M17.5 22H6.5C4 22 2 20 2 17.5C2 15 4 13 6.5 13H17.5C20 13 22 15 22 17.5C22 20 20 22 17.5 22ZM4 17.5C4 18.9 5.1 20 6.5 20C7.9 20 9 18.9 9 17.5C9 16.1 7.9 15 6.5 15C5.1 15 4 16.1 4 17.5Z",
          fill: "black"
        })
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-icon btn-active-light-primary w-30px h-30px",
    "data-kt-permissions-table-filter": "delete_row"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3" }, [
      /*#__PURE__*/_createElementVNode("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
      }, [
        /*#__PURE__*/_createElementVNode("path", {
          d: "M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z",
          fill: "black"
        }),
        /*#__PURE__*/_createElementVNode("path", {
          opacity: "0.5",
          d: "M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z",
          fill: "black"
        }),
        /*#__PURE__*/_createElementVNode("path", {
          opacity: "0.5",
          d: "M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z",
          fill: "black"
        })
      ])
    ])
  ])
], -1)
const _hoisted_54 = {
  href: "../../demo1/dist/apps/user-management/roles/view.html",
  class: "badge badge-light-primary fs-7 m-1"
}
const _hoisted_55 = {
  href: "../../demo1/dist/apps/user-management/roles/view.html",
  class: "badge badge-light-danger fs-7 m-1"
}
const _hoisted_56 = /*#__PURE__*/_createElementVNode("td", null, "20 Jun 2021, 5:20 pm", -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-icon btn-active-light-primary w-30px h-30px me-3",
    "data-bs-toggle": "modal",
    "data-bs-target": "#kt_modal_update_permission"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3" }, [
      /*#__PURE__*/_createElementVNode("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
      }, [
        /*#__PURE__*/_createElementVNode("path", {
          d: "M17.5 11H6.5C4 11 2 9 2 6.5C2 4 4 2 6.5 2H17.5C20 2 22 4 22 6.5C22 9 20 11 17.5 11ZM15 6.5C15 7.9 16.1 9 17.5 9C18.9 9 20 7.9 20 6.5C20 5.1 18.9 4 17.5 4C16.1 4 15 5.1 15 6.5Z",
          fill: "black"
        }),
        /*#__PURE__*/_createElementVNode("path", {
          opacity: "0.3",
          d: "M17.5 22H6.5C4 22 2 20 2 17.5C2 15 4 13 6.5 13H17.5C20 13 22 15 22 17.5C22 20 20 22 17.5 22ZM4 17.5C4 18.9 5.1 20 6.5 20C7.9 20 9 18.9 9 17.5C9 16.1 7.9 15 6.5 15C5.1 15 4 16.1 4 17.5Z",
          fill: "black"
        })
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-icon btn-active-light-primary w-30px h-30px",
    "data-kt-permissions-table-filter": "delete_row"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3" }, [
      /*#__PURE__*/_createElementVNode("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
      }, [
        /*#__PURE__*/_createElementVNode("path", {
          d: "M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z",
          fill: "black"
        }),
        /*#__PURE__*/_createElementVNode("path", {
          opacity: "0.5",
          d: "M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z",
          fill: "black"
        }),
        /*#__PURE__*/_createElementVNode("path", {
          opacity: "0.5",
          d: "M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z",
          fill: "black"
        })
      ])
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KTAddPermission = _resolveComponent("KTAddPermission")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", _hoisted_5, [
            _hoisted_6,
            _createTextVNode(_toDisplayString(_ctx.$t("permissionAdd")), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("table", _hoisted_8, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", _hoisted_9, [
              _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t("name")), 1),
              _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t("assignedTo")), 1),
              _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t("creationDate")), 1),
              _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t("actions")), 1)
            ])
          ]),
          _createElementVNode("tbody", _hoisted_14, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, _toDisplayString(_ctx.$t("userManagement")), 1),
              _createElementVNode("td", null, [
                _createElementVNode("a", _hoisted_15, _toDisplayString(_ctx.$t("administrator")), 1)
              ]),
              _hoisted_16,
              _hoisted_17
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, _toDisplayString(_ctx.$t("contentManagement")), 1),
              _createElementVNode("td", null, [
                _createElementVNode("a", _hoisted_18, _toDisplayString(_ctx.$t("administrator")), 1),
                _createElementVNode("a", _hoisted_19, _toDisplayString(_ctx.$t("developer")), 1),
                _createElementVNode("a", _hoisted_20, _toDisplayString(_ctx.$t("analyst")), 1),
                _createElementVNode("a", _hoisted_21, _toDisplayString(_ctx.$t("support")), 1),
                _createElementVNode("a", _hoisted_22, _toDisplayString(_ctx.$t("trial")), 1)
              ]),
              _hoisted_23,
              _hoisted_24
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, _toDisplayString(_ctx.$t("financialManagement")), 1),
              _createElementVNode("td", null, [
                _createElementVNode("a", _hoisted_25, _toDisplayString(_ctx.$t("administrator")), 1),
                _createElementVNode("a", _hoisted_26, _toDisplayString(_ctx.$t("analyst")), 1)
              ]),
              _hoisted_27,
              _hoisted_28
            ]),
            _createElementVNode("tr", null, [
              _hoisted_29,
              _createElementVNode("td", null, [
                _createElementVNode("a", _hoisted_30, _toDisplayString(_ctx.$t("administrator")), 1),
                _createElementVNode("a", _hoisted_31, _toDisplayString(_ctx.$t("analyst")), 1)
              ]),
              _hoisted_32,
              _hoisted_33
            ]),
            _createElementVNode("tr", null, [
              _hoisted_34,
              _createElementVNode("td", null, [
                _createElementVNode("a", _hoisted_35, _toDisplayString(_ctx.$t("administrator")), 1),
                _createElementVNode("a", _hoisted_36, _toDisplayString(_ctx.$t("analyst")), 1)
              ]),
              _hoisted_37,
              _hoisted_38
            ]),
            _createElementVNode("tr", null, [
              _hoisted_39,
              _createElementVNode("td", null, [
                _createElementVNode("a", _hoisted_40, _toDisplayString(_ctx.$t("administrator")), 1),
                _hoisted_41,
                _hoisted_42
              ]),
              _hoisted_43,
              _hoisted_44
            ]),
            _createElementVNode("tr", null, [
              _hoisted_45,
              _createElementVNode("td", null, [
                _createElementVNode("a", _hoisted_46, _toDisplayString(_ctx.$t("administrator")), 1),
                _createElementVNode("a", _hoisted_47, _toDisplayString(_ctx.$t("developer")), 1)
              ]),
              _hoisted_48,
              _hoisted_49
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, _toDisplayString(_ctx.$t("dbManagement")), 1),
              _createElementVNode("td", null, [
                _createElementVNode("a", _hoisted_50, _toDisplayString(_ctx.$t("administrator")), 1),
                _createElementVNode("a", _hoisted_51, _toDisplayString(_ctx.$t("developer")), 1)
              ]),
              _hoisted_52,
              _hoisted_53
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, _toDisplayString(_ctx.$t("repoManagement")), 1),
              _createElementVNode("td", null, [
                _createElementVNode("a", _hoisted_54, _toDisplayString(_ctx.$t("administrator")), 1),
                _createElementVNode("a", _hoisted_55, _toDisplayString(_ctx.$t("developer")), 1)
              ]),
              _hoisted_56,
              _hoisted_57
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_KTAddPermission)
  ], 64))
}